import React from 'react';

import PopUp from '../../Popup';
import LearnMoreUtrCollegeContent from './LearnMoreUtrCollegeContent';

const LearnMoreUtrCollegePopUp = (props) => {
    const { onCloseClick, handleUpgradeClick, clubOptionsToUpgrade, 'data-testid': dataTestId } = props;
    return (
        <div data-testid={dataTestId}>
            <PopUp
                className="popup-md"
                config={{
                    style: {
                        height: 540,
                        maxHeight: '80vh',
                    },
                    fullScreen: true,
                    noPadding: false,
                }}
                onCloseClick={onCloseClick}
            >
                <LearnMoreUtrCollegeContent
                    handleUpgradeClick={handleUpgradeClick}
                    clubOptionsToUpgrade={clubOptionsToUpgrade}
                    data-testid={dataTestId ? `${dataTestId}.content` : undefined}
                />
            </PopUp>
        </div>
    );
};

export default LearnMoreUtrCollegePopUp;
